import React, { useMemo } from 'react';
import classes from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import styles from './AvgStudentProgressAtCurrentLevelChar.module.scss';
import { StudentMetricsDashboardProgressAtCurrentLevel } from '@/school-management/types/generate-report';
import { normalizeStudentMetricsDashboardProgressAtCurrentLevelData } from '../normalizeData';

interface AvgStudentProgressAtCurrentLevelCharProps {
  data?: StudentMetricsDashboardProgressAtCurrentLevel[];
  onLevelSelect?: (level: number) => void;
}

const AvgStudentProgressAtCurrentLevelChar: React.FC<AvgStudentProgressAtCurrentLevelCharProps> = ({
  data,
  onLevelSelect,
}) => {
  const { t } = useAdminTranslation();

  const levels = useMemo(() => {
    const levelsData = normalizeStudentMetricsDashboardProgressAtCurrentLevelData(data);

    return levelsData;
  }, [data]);

  return (
    <div className={styles.chart}>
      {levels.map(item => {
        const progress = Math.min(Math.max(item.averageProgressPercent, 0), 100);

        return (
          <div key={item.level} className={styles.levelBar}>
            <div className={styles.levelInfo}>
              {t('studentMetricsDashboard.charts.avgStudentProgressAtCurrentLevel.levelInfo', {
                level: item.level,
                studentCount: item.studentCount,
              })}
            </div>
            <div className={styles.progressBarContainer}>
              <div className={styles.progressBarBackground}>
                {progress > 0 && (
                  <div
                    className={classes(styles.progressBarFill, {
                      [styles[item.color]]: !!item.color,
                    })}
                    style={{
                      width: `${progress}%`,
                      cursor: item.studentCount > 0 ? 'pointer' : 'default',
                    }}
                    onClick={() => {
                      if (item.studentCount > 0) {
                        onLevelSelect?.(item.level);
                      }
                    }}
                  >
                    <span className={styles.progressValue}>{progress}%</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AvgStudentProgressAtCurrentLevelChar;
